import React from 'react';

const Blogs = () => {
      return (
            <section style={{fontFamily: 'Roboto Mono',marginTop:'80px'}} className='container'>
                  <h1 className='brand fs-2 brand-link'>Blog</h1>
                  <div className="row mt-5">
                  <div data-aos="fade-right" className="col-md-6">
                        <h2 style={{color:'#ff0b56'}}>Top Front End Developer Question</h2>
                        <p className='text-white'>April 1, 2021</p>
                        <article style={{color:'#6c757d'}}>So, here are the Top 50 React Interview Questions and Answers which are most likely to be asked by the interviewer. For your ease of access, I have categorized the React interview questions
                        <br /><span className='brand-link brand link'>Read more...</span>
                        </article>
                  </div>
                  <div data-aos="fade-left" className="col-md-6">
                        <h2 style={{color:'#ff0b56'}}>Web Development Guideline- How to start?</h2>
                        <p className='text-white'>January 25, 2021</p>
                        <article style={{color:'#6c757d'}}>
                        This article is meant to serve as a practical guide to becoming a professional web developer. I’ve spent over 20 years writing code for the web. I work with and help developers daily. In this article, I will tell you what you should learn, when you should learn it, and where you can learn it from.
                        <br /><span className='brand-link brand link'>Read more...</span>
                        </article>
                  </div>
                  </div>
                  <div className="row mt-5">
                  <div data-aos="fade-right" className="col-md-6">
                        <h2 style={{color:'#ff0b56'}}>Looking for ReactJS Developer?</h2>
                        <p className='text-white'>March 14, 2021</p>
                        <article style={{color:'#6c757d'}}>
                        Toptal offers top React.js developers, programmers, and software engineers. For those looking to work remotely with the best engineers, look no further
                        <br /><span className='brand-link brand link'>Read more...</span>
                        </article>
                  </div>
                  <div data-aos="fade-left" className="col-md-6">
                        <h2 style={{color:'#ff0b56'}}>How much a front end developer can make?</h2>
                        <p className='text-white'>May 5, 2021</p>
                        <article style={{color:'#6c757d'}}>
                        According to Glassdoor, a front end developer in the United States can earn an average of $86,178 per year. A “regular” front-end developer can earn an average salary of $71,350 a year, according to Payscale.
                        <br /><span className='brand-link brand link'>Read more...</span>
                        </article>
                  </div>
                  </div>
            </section>
      );
};

export default Blogs;